import React, { useContext } from 'react'
import { AppContext } from 'contexts/AppProvider'
import { useTranslation } from 'react-i18next'
import { Fonts, Icon } from 'components/base-ui'
import { Wrapper, Header, Avatar, UserInfo, MembershipCard, Name, Tier, Footer } from './styled'

interface UserCardProps {
  name: string
  tier: string
  points: number
  avatarUrl: string
  tierImage: string
}

const UserCard: React.FC<UserCardProps> = ({ name, tier, points, avatarUrl, tierImage }) => {
  const { brand } = useContext(AppContext)
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Header>
        <Avatar src={avatarUrl || '/assets/dine-in/avatar.png'} alt={`${name}'s avatar`} />
        <UserInfo>
          <Name>{name}</Name>
          <Tier>Tier: {tier}</Tier>
        </UserInfo>
        <MembershipCard src={tierImage} alt="" />
      </Header>
      <Footer>
        <Icon name="star-circle" color={brand?.theme.colors.primary} size="18px" />
        <Fonts.SmallTitleBold>
          {points} {t('dineIn.privilege.point')}
        </Fonts.SmallTitleBold>
      </Footer>
    </Wrapper>
  )
}

export default UserCard
